import React, { Component, Fragment } from "react";
import {
  Form,
  Grid,
} from "semantic-ui-react";
import { showModal } from "./../../actions/categories/showModal";
import { fetchAllCategories } from "./../../actions/categories/fetchAllCategories";
import { addCategory } from "./../../actions/categories/addCategory";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import semanticFormField from "./FormComponents/semanticFormField";
import { required } from "./FormComponents/validation";

class AddCategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      code: "",
      type: "",
    };
  }

  // callback to parent to make submit state false -
  // Reason : incasae validation fails submit does'nt work second time
  setModalSubStateToFalse = () => {
    this.props.setFalse(false);
  };
/*
  handleChange = e => {
    let change = {};
    let value = e.target.value; 
    change[e.target.name] = value ? value.trim() : value;
    console.log(change);  
    this.setState(change);
  };
*/
/*
  handleChangeDropdown = (e, data) => {
    this.setState({
      type: data.value
    });
  };
*/

  onClose = () => {
    // dispatch show modal acction here
    this.props.showModal({
      state: false,
      modalName: "Add Category",
      component: "ADD_CATEGORY_FORM",
      size: "small",
      submitBtn: "Submit",
      denyBtn: "Cancel"
    });
  };

  categoryIsPresent = value => 
    this.props.categories.map(elem => elem.name).includes(value)
      ? "A Category already exists with that name. Please try again"
      : undefined;

  codeIsPresent = value =>
    this.props.categories.map(elem => elem.code).includes(value)
      ? "A Category already exists with that code. Please try again"
      : undefined;

    isCategoryNameHasSpecial = (value) => (/^([a-zA-Z0-9_/-]+( [a-zA-Z0-9_/-]+)*)$/.test(value ? value.trim(): value)) ? undefined : 'Category should not contain special characters';

    isCategoryNameToBig = (value) => {
      if (typeof value === 'string') {
        if (value.length > 100) {
          return 'Category should not contain more than 100 characters'
        }
        return undefined;
      }
      return undefined;
    }

    isCodeHasSpecialOrBig = (value) => {
      if (!(/^([a-zA-Z0-9_-]){1,10}$/.test(value))) {
        if (value.length > 10) {
          return 'Code should not contain more than 10 characters'
        }
        return 'Code should not contain special characters'
      }
      return undefined;
    }
    

  render() {
    const { handleSubmit, onSubmit } = this.props;

    const typeOptions = this.props.categoryTypes.map(elem => {
      return {
        key: elem,
        value: elem,
        text: elem
      };
    });

    return (
      <Fragment>
        <Form id="addCatForm" onSubmit={handleSubmit(onSubmit)}>
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column width={8}>
                <Form.Field required>
                  <label> Category Name </label>
                </Form.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <Field
                  name="name"
                  component={semanticFormField}
                  as={Form.Input}
                  type="text"
                  label="Category Name"
                  placeholder="Category Name"
                  validate={[this.categoryIsPresent, this.isCategoryNameHasSpecial, this.isCategoryNameToBig, required]}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={8}>
                <Form.Field required>
                  <label> Code </label>
                </Form.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <Field
                  name="code"
                  component={semanticFormField}
                  as={Form.Input}
                  type="text"
                  label="Code"
                  placeholder="Code"
                  validate={[this.codeIsPresent, this.isCodeHasSpecialOrBig ,required]}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={8}>
                <Form.Field required>
                  <label> Type</label>
                </Form.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <Field
                  name="type"
                  component={semanticFormField}
                  as={Form.Select}
                  options={typeOptions}
                  type="text"
                  label="Type"
                  placeholder="Type"
                  validate={required}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    showModal: state.allCategories.showModal,
    categories: state.allCategories.categories,
    categoryTypes: state.allCategories.categoryTypes,
    shouldShowModal: state.allCategories.showModal,
    formValues: state.form.AddCategoryForm
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {showModal, fetchAllCategories, addCategory},
    dispatch
  );
}

const AddCatForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCategoryForm);

export default reduxForm({
  form: "AddCategoryForm" // a unique name for this form
})(AddCatForm);